import axios from '../utils/axios'
let comApi = {
    //获取元器件列表
    getcomponentlist(params,success){
        axios('/componentlist/getcomponentlist',params,success)
    },
    //增加元器件
    addcom(params,success){
        axios('/componentlist/addcom',params,success)
    },
    //删除元器件
    delcomponentlist(params,success){
        axios('/componentlist/delcomponentlist',params,success)
    },
    //根据mapid删除元器件
    delComponent(params,success){
        axios('/componentlist/delcomponent',params,success)
    },
    //修改元器件
    changecom(params,success){
        axios('/componentlist/changecom',params,success)
    }
        
}
export default comApi


// WEBPACK FOOTER //
// ./src/api/component.js